import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog';
import { Button } from './ui/button';

/**
 * Generic confirm/cancel dialog built on our Radix Dialog primitive.
 * Drop-in replacement for the old Bootstrap Modal used across admin screens.
 *
 *   <ConfirmModal
 *     show={showModal}
 *     title="Eliminar rifa"
 *     message="¿Estás seguro?"
 *     onConfirm={handleConfirm}
 *     onCancel={handleClose}
 *     confirmLabel="Eliminar"
 *     cancelLabel="Cancelar"
 *     destructive   // optional — makes confirm button red
 *   />
 */
function ConfirmModal({
  show,
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  destructive = false,
}) {
  return (
    <Dialog open={show} onOpenChange={open => !open && onCancel()}>
      <DialogContent className='sm:max-w-md'>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {message && <DialogDescription>{message}</DialogDescription>}
        </DialogHeader>
        <DialogFooter>
          <Button variant='outline' onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant={destructive ? 'destructive' : 'default'} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ConfirmModal;
